export const GET_PUBLISHED_EVENTS_PENDING = "GET_PUBLISHED_EVENTS_PENDING";
export const SET_PUBLISHED_EVENTS = "SET_PUBLISHED_EVENTS";
export const SET_EVENTS_QUESTION = "SET_EVENTS_QUESTION";
export const SET_CURRENT_EVENT_ID = "SET_CURRENT_EVENT_ID";
export const SET_QUESTIONS_DATA = "SET_QUESTIONS_DATA";
export const SET_ANSWER_RESPONSE = "SET_ANSWER_RESPONSE";
export const SET_UPLOAD_RESPONSE = "SET_UPLOAD_RESPONSE";
export const SET_CURRENT_EVENT_NAME = "SET_CURRENT_EVENT_NAME";
export const SET_UPLOAD_SUCCESS_PENDING = "SET_UPLOAD_SUCCESS_PENDING";
export const SET_TIMER_BOOLEAN = "SET_TIMER_BOOLEAN";
export const SET_ACTIVE_QUES_ID = "SET_ACTIVE_QUES_ID";
export const SET_IS_GET_PUBLISHED_EVENT_PENDING = "SET_IS_GET_PUBLISHED_EVENT_PENDING";
export const SET_IS_GET_QUESTIONS_LIST_PENDING = "SET_IS_GET_QUESTIONS_LIST_PENDING";
export const SET_IS_GET_QUESTION_DATA_PENDING = "SET_IS_GET_QUESTION_DATA_PENDING";
export const SET_IS_SUBMIT_ANSWER_PENDING = "SET_IS_SUBMIT_ANSWER_PENDING";
export const INIT_AUTOEVAL_DIALOG= "INIT_AUTOEVAL_DIALOG";
export const SET_PROGRESS_VALUE = "SET_PROGRESS_VALUE";
export const SET_PROGRESS_NAME = "SET_PROGRESS_NAME";
export const SET_AUTOEVAL_RESULT_STATUS = "SET_AUTOEVAL_RESULT_STATUS";
export const SET_AUTOEVAL_RESULT_STRING = "SET_AUTOEVAL_RESULT_STRING";
export const SET_CURRENT_EVENT_TYPE = "SET_CURRENT_EVENT_TYPE";